import React, {useEffect} from 'react';
import {Button, Input, InputGroup} from 'reactstrap';
import logo from '../../img/newsfetch-io.png';
import {connect} from 'react-redux';
import {logoutWithoutRedirect} from 'redux/modules/auth/action';
import {useHistory} from 'react-router-dom';

function ExpiredToken(props) {
    let history = useHistory();

    useEffect(() => {
        if(props.auth.isAuthenticated) {
            props.logoutWithoutRedirect();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const redirectToHomepage = () => {
        console.log('expired token redirect')
        history.push('/signin');
    };

    return (
        <div className="d-flex flex-column justify-content-center align-items-center"
             style={{height: 'calc(100vh - 100px)', width: '100%'}}>
            <div className="d-flex flex-column p-4 authorization-container">
                <div className="text-center">
                    <h3 className="align-self-center mb-2" style={{fontWeight: '700', fontFamily: 'Sans-serif'}}>
                        Expired Link
                    </h3>
                    <p className="align-self-center mb-3 text-center">
                        The link that you clicked has expired or has
                        already been used. Please return to the login screen or contact your administrator to request a new link.
                    </p>
                    <div className="d-flex flex-column align-self-start">
                        <Button
                            className="calltoaction-button"
                            onClick={redirectToHomepage}
                        >
                            Return to Login
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, {logoutWithoutRedirect})(ExpiredToken);